import productApi from "./productApi";
import categoryApi from "./categoryApi";
import deliveryApi from "./deliveryApi";
import paymentApi from "./paymentApi";
import giftApi from "./giftApi";
import additionApi from "./additionApi";
import settingApi from "./settingApi";
import levelApi from "./levelApi";
import customerApi from "./customerApi";
import promotionApi from "./promotionApi";
import pageApi from "./pageApi";
import userApi from "./userApi";

export default {
  productApi: productApi,
  categoryApi: categoryApi,
  deliveryApi: deliveryApi,
  paymentApi: paymentApi,
  giftApi: giftApi,
  additionApi: additionApi,
  settingApi: settingApi,
  levelApi: levelApi,
  customerApi: customerApi,
  promotionApi: promotionApi,
  pageApi: pageApi,
  userApi: userApi,
};
